import { Icon } from "@mui/material";
import React from "react";
import "./InfoTooltip.css";

const IconHolder = ({ iconName, iconColor }) => {
  return <Icon className={"followup_clockColor_" + iconColor}>{iconName}</Icon>;
};

export default IconHolder;
